import { render } from "./SessionMetadataModal.vue?vue&type=template&id=65ec7d2a&scoped=true"
import script from "./SessionMetadataModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./SessionMetadataModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./SessionMetadataModal.vue?vue&type=style&index=0&id=65ec7d2a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ec7d2a"]])

export default __exports__